import { DateTime } from 'luxon';

export const getNextBusinessDay = ({
  startDate,
  direction,
  excludedDays,
  includeStartDate,
}: {
  startDate: DateTime;
  direction: 'forward' | 'backward';
  excludedDays: DateTime[];
  includeStartDate: boolean;
}): DateTime => {
  const nextDay = includeStartDate ? startDate : startDate.plus({ days: direction === 'forward' ? 1 : -1 });

  const isNotWeekend = nextDay.weekday < 6; // 1 (Monday) ... 6 (Saturday), 7 (Sunday)
  const isNotHoliday = excludedDays.findIndex((dt) => dt.hasSame(nextDay, 'day')) === -1;

  if (isNotWeekend && isNotHoliday) {
    return nextDay;
  }

  return getNextBusinessDay({ startDate: nextDay, direction, excludedDays, includeStartDate: false });
};

/**
 * Given a starting date return the date N business days away, either forward or backward. Useful for getting
 * e.g. the 4th business day of the month, by passing in the 1st of the month with direction="forward".
 */
export const getNthBusinessDay = ({
  startDate,
  direction,
  excludedDays,
  includeStartDate,
  n,
}: {
  startDate: DateTime;
  direction: 'forward' | 'backward';
  excludedDays: DateTime[];
  includeStartDate: boolean;
  n: number;
}): DateTime => {
  const nextDay = includeStartDate ? startDate : startDate.plus({ days: direction === 'forward' ? 1 : -1 });

  const isNotWeekend = nextDay.weekday < 6; // 1 (Monday) ... 6 (Saturday), 7 (Sunday)
  const isNotHoliday = excludedDays.findIndex((dt) => dt.hasSame(nextDay, 'day')) === -1;

  if (n === 1 && isNotWeekend && isNotHoliday) {
    return nextDay;
  }

  return getNthBusinessDay({
    startDate: nextDay,
    direction,
    excludedDays,
    includeStartDate: false,
    n: isNotWeekend && isNotHoliday ? n - 1 : n,
  });
};
